import $ from '../utils/jquery';

const $stateSelect = $( '#pdf-links' );
const $downloadBtn = $( '.download-btn' );

const syncButtonState = () => {
	const link = $stateSelect.val();
	$downloadBtn.prop( 'disabled', ! link || link === '#' );
};

const bind = () => {
	$stateSelect.on( 'change', syncButtonState );

	// Re-sync on bfcache restore (e.g. browser back button), where the
	// select keeps its value but the module's load check doesn't re-run.
	$( window ).on( 'pageshow', syncButtonState );

	$downloadBtn.on( 'click', function( e ) {
		e.preventDefault();
		const link = $stateSelect.val();

		if ( link && link !== '#' ) {
			// Open the PDF in a new tab so the user keeps their place on the page.
			// A synthetic anchor click is used instead of window.open() because
			// window.open() with 'noopener' returns null in most browsers, which
			// makes a "did it open?" fallback fire even when it succeeded.
			const a = document.createElement( 'a' );
			a.href = link;
			a.target = '_blank';
			a.rel = 'noopener noreferrer';
			document.body.appendChild( a );
			a.click();
			a.remove();
		}
	} );
}

export default () => {
	if ( ! $stateSelect.length ) {
		return;
	}

	syncButtonState();
	bind();
};
